import React, {Component, Fragment} from 'react';
import { SingleDatePicker } from 'react-dates';
import Moment from 'moment';
import TimePicker from 'rc-time-picker';



// import BiddingDetails from 'Models/BiddingDetails';
import Heading from 'Components/Heading';
import SubHeading from 'Components/SubHeading'
import Checkbox from 'Components/Checkbox';
import Dropdown from 'Components/Dropdown';
import Input from 'Components/Input'
import { isAdaniWilmar } from 'Utils/';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import Cx from 'classnames';

import {
    TAT_UNITS,
    AVG_DISTANCE,
    GREEN_PLY,
    KRBL,
    BEAM,
    ARDEX
} from 'Constants/commonConstants';
import { CENTURY_PLY , HIKAL, MITSUI } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import { isBeamS, isCoromandel, isVishaka } from 'Utils/index';

const RFQ_TYPE = "rfq";
const TRIP_TYPE = "trip";
class BiddingAndPayment extends Component {
    constructor(props) {
        super(props);
        const biddingDetails = props.biddingDetails;
        this.viewMode = props.viewMode;
        this.viewType = props.viewType;
        this.biddingDetails = biddingDetails;
        this.state = {
            biddingDetails,
            isMissingUOM: false,
            businessVolumes: this.props.businessVolumes,
            isConfirmation: false
        }
    }
    componentDidMount() {
        const { businessVolumes, rfq, pricingBasis ,dphDetails} = this.props;
        const hasOption = businessVolumes.filter((business) => { return business.value === '' });
        if (hasOption && hasOption.length <= 0) {
            (businessVolumes || []).unshift({ 
                name: 'Select UOM',
                value: '',
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const {dphDetails} = this.props;
        const {biddingDetails} = this.state;
        if (prevProps.dphDetails !== dphDetails) {
            biddingDetails.diesel_price = dphDetails.diesel
            this.setState({biddingDetails})
        }
      }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rfq, pricingBasis } = nextProps;
        if(isAdaniWilmar() && rfq && (pricingBasis || []).length > 0 && this.viewType !== TRIP_TYPE && this.props.rfqType === 3 && this.biddingDetails && !this.biddingDetails.pricingBasis) {
            const pricingBasislist = (pricingBasis || []).find(pricing => pricing.value == (((rfq || {}).rfqDetails || {}).secondaryContractType === 2 ? 6 : 17));
            if(pricingBasislist) {
                this.biddingDetails.setPricingBasis(pricingBasislist);
                this.setState({
                    biddingDetails: this.biddingDetails
                });
                this.props.onChange();
            }
        }
    }
    onSelect = (value, name)=> {
        const isAdminEditable = name === "pricingBasis" || name === "paymentCycle";
        if(this.viewMode && !isAdminEditable) {
            return;
        }
        if(this.viewType === TRIP_TYPE && isAdminEditable) {
            return;
        }
        this.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            biddingDetails: { ...this.biddingDetails }
        })
        this.props.onChange()
    }
    changePaymentTerms = (value)=> {
        if(this.viewMode || this.viewType === TRIP_TYPE) {
            return;
        }
        this.biddingDetails.setPaymentTerms(value, null, (value === 2 ? 'To Be Billed' : 'To Pay'));
        this.setState({
            biddingDetails: this.biddingDetails
        })
        this.props.onChange()
    }
    onSelectIncoTerms = (value)=> {
        if(this.viewMode || this.viewType === TRIP_TYPE) {
            return;
        }
        this.biddingDetails.setIncoTerms(value);
        this.setState({
            biddingDetails: this.biddingDetails
        })
        this.props.onChange()
    }
    onChange = (e)=> {
        if(this.viewMode) {
            return;
        }
        
        const { rfq } = this.props;
        const name = e.target.name;
        const value = e.target.value;
        if(value < 0) {
            return;
        }
        if(isAdaniWilmar() && name === 'qbr' && this.biddingDetails.pricingBasis === 6 && [6,10].includes(rfq.pricing_bassis_with_qbr_rate_id) && value > Number(rfq.pricing_basis_qbr_rate || 0)) {
            return;
        }
        this.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        if ((isAdaniWilmar() || GREEN_PLY.includes(rfq.companyId) || ARDEX.includes(rfq.companyId))&& this.biddingDetails.systemSuggestedPrice > 0) {
            const sSPrice = this.biddingDetails.systemSuggestedPrice;
            if(this.biddingDetails.qbr > (sSPrice + (sSPrice * 0.1))) {
                this.setState({
                    isConfirmation: true
                })
            }
        }
        this.biddingDetails["businessVolumeUnitName"]=this.biddingDetails.businessVolumeUnitName==="Select UOM"?"":this.biddingDetails.businessVolumeUnitName;
        this.setState({
            biddingDetails: this.biddingDetails
        })
        this.props.onChange()
    }
    checkIsOutside = (date, rfqServiceType) => {
        const { systemTime } = this.props;
        if(rfqServiceType === 4)
            // !Moment(date).isBetween(Moment(new Date()).subtract(1,'days'), Moment(new Date()).add(6, 'days'));
            return !Moment(date).isBetween(Moment(new Date(systemTime)).subtract(1,'days'), Moment(new Date(systemTime)).add(6, 'days'));
        else 
            // date < new Date().setHours(0);
            return date < new Date(systemTime).setHours(0);
    }

    onCancel = () => {
        this.biddingDetails.setQbr(this.biddingDetails.systemSuggestedPrice);
        this.setState({
            biddingDetails: this.biddingDetails,
            isConfirmation: false
        })
        this.props.onChange()
    }

    getPricingBasis = (type) => {
        const { rfq } = this.props;
        if(type === 6) {
            return `in MT ${([6, 10].includes(rfq.pricing_bassis_with_qbr_rate_id) && rfq.pricing_basis_qbr_rate) ? `& price should be <= ${rfq.pricing_basis_qbr_rate}` : ''}`;
        } else if(type === 17) {
            return 'in Rate/Trip';
        }
        return '';
    }
    shouldRenderDieselprice = () => {
        const user = getUser();
        const isBeam = BEAM.includes(user.companyId);
        if(isBeam){
           return true;
        }
        return false; 
  
     }
     
     shouldRenderSystemSuggestedPrice = (rfq) => {
         const isAdani = isAdaniWilmar() 
         const isGreenPly = GREEN_PLY.includes(rfq.companyId)
         const isAredx = ARDEX.includes(rfq.companyId)
         if (isAdani || isGreenPly || isAredx){
            return true
         }
         return false
     }
    

    render() {
        const { biddingDetails } = this.state;
        const { 
            paymentCycles,
            pricingBasis,
            lppDetails,
            submitted,
            viewType,
            type,
            rfqServiceType,
            bidEndTimeValue,
            systemTime,
            rfq,
            rfqType,
            incotermsList,
            dphDetails
        } = this.props;
        const {
            businessVolumes,
        } = this.state;
        console.log('rfq', rfq);
        const hasDefault = TAT_UNITS.filter((tat) => { return tat.value === '' });
        const { ftlContractType } = (rfq || {}).rfqDetails || {}
        if (hasDefault && hasDefault.length <= 0) {
            TAT_UNITS.unshift({
                name: 'Select days/hrs',
                value: '',
            })
        }
        // const dphResult = dphDetails && dphDetails.filter( ( data ) => { return data.city === 'Vadodara' });
        const dphResult = dphDetails 
       
        return (
            <Fragment>
            <div className="flex flex-between">
                <div className="col-2 pr-20">
                    { type !== 'addTrip' &&
                        <React.Fragment>
                            <Heading type="medium" text="Bidding Info" className="mb-20"/>
                            <div className="mb-20">
                                <SubHeading text="Bidding From" className="mb-10" mandatory={true}/>
                                <div className="flex pb-20 mb-20 mt--1">
                                    <SingleDatePicker
                                        noBorder={true}
                                        displayFormat={"DD MMM YYYY"}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"Placement Date"}
                                        numberOfMonths={2}
                                        date={Moment(this.biddingDetails.from)} 
                                        onDateChange={(from) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE) {
                                                return;
                                            }
                                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(this.biddingDetails.from).format('HH:mm')
                                            this.biddingDetails.setFrom(new Date(date).getTime());
                                            if(bidEndTimeValue > 0) {
                                                this.biddingDetails.setTo(new Date(date).getTime() + bidEndTimeValue);
                                            }
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        focused={this.state.focusedStart} 
                                        onFocusChange={({ focused }) => this.setState({ focusedStart: (this.viewMode || this.viewType === TRIP_TYPE)?null:focused })} 
                                        isOutsideRange={(date) => date < new Date(systemTime).setHours(0)}
                                        // isOutsideRange={(date) => date < Moment(systemTime).setHours(0)}
                                        disabled={isVishaka()}
                                    />
                                    <TimePicker
                                        showSecond={false}
                                        value={Moment(this.biddingDetails.from)}
                                        className="ht-40 wt-150 border-status-bar br-5"
                                        onChange={(from) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE) {
                                                return;
                                            }
                                            const date = Moment(this.biddingDetails.from).format('YYYY-MM-DD') + ' ' + from.format('HH:mm')
                                            this.biddingDetails.setFrom(new Date(date).getTime());
                                            if(bidEndTimeValue > 0) {
                                                this.biddingDetails.setTo(new Date(date).getTime() + bidEndTimeValue);
                                            }
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        // minTime={new Date()}
                                        minTime={Moment(systemTime)}
                                        format={'h:mm a'}
                                        use12Hours
                                        inputReadOnly
                                        disabled={this.viewMode || this.viewType === TRIP_TYPE || isVishaka()}
                                    />
                                </div>
                                {submitted && 
// (Moment(this.state.biddingDetails.from) > Moment(new Date())) &&
                                (Moment(this.state.biddingDetails.from) > Moment(new Date(this.props.systemTime))) &&
                                <span className="error-color fs-14 fSemibold op-7 ml-5">Bidding Date Should Be From Current Date</span>}
                                <SubHeading text="Bidding To" className="mb-10" mandatory={true}/>
                                <div className="flex pb-20">
                                    <SingleDatePicker
                                        noBorder={true}
                                        displayFormat={"DD MMM YYYY"}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"Please Add Bidding To"}
                                        numberOfMonths={2}
                                        date={this.biddingDetails.to?Moment(this.biddingDetails.to):null} 
                                        onDateChange={(from) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE) {
                                                return;
                                            }
                                            // const date = from.format('YYYY-MM-DD') + ' ' + Moment(this.biddingDetails.to?this.biddingDetails.to:new Date().getTime()).format('HH:mm')
                                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(this.biddingDetails.to?this.biddingDetails.to: systemTime).format('HH:mm')
                                            this.biddingDetails.setTo(new Date(date).getTime());
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        focused={this.state.focusedEnd} 
                                        onFocusChange={({ focused }) => this.setState({ focusedEnd: (this.viewMode || this.viewType === TRIP_TYPE)?null:focused })}
                                        isOutsideRange={(date) => this.checkIsOutside(date, rfqServiceType)}
                                        disabled={isVishaka()}
                                    />
                                    <TimePicker
                                        showSecond={false}
                                        value={this.biddingDetails.to?Moment(this.biddingDetails.to): null}
                                        className="ht-40 wt-150 border-status-bar br-5"
                                        onChange={(to) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE || !this.biddingDetails.to) {
                                                return;
                                            }
                                            const date = Moment(this.biddingDetails.to).format('YYYY-MM-DD') + ' ' + to.format('HH:mm')
                                            this.biddingDetails.setTo(new Date(date).getTime());
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        // minTime={new Date()}
                                        minTime={Moment(systemTime)}
                                        format={'h:mm a'}
                                        use12Hours
                                        inputReadOnly
                                        disabled={this.viewMode || !this.biddingDetails.to || this.viewType === TRIP_TYPE || isVishaka()}
                                    />
                                </div>
                                {submitted && !(this.state.biddingDetails.to) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select Bidding Time</span>}
                                {submitted &&(this.state.biddingDetails.to)&& !(this.state.biddingDetails.to > this.state.biddingDetails.from) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please select Valid Bid Time</span>}
                                {submitted &&
                                //  (this.state.biddingDetails.to > Moment(new Date()).add(6, 'days').valueOf()) &&
                                 (this.state.biddingDetails.to > Moment(systemTime).add(6, 'days').valueOf()) &&  
                                 <span className="error-color fs-14 fSemibold op-7 ml-5">Bidding To Time For Container Service Type Should Be Between 7 Days</span>}
                            </div>
                        

                            {![6, 9, 10].includes(rfqType) && <div className="mb-40">
                                <SubHeading mandatory={true} text="Pricing Basis" className="mb-10"/>
                                <Dropdown 
                                    items={pricingBasis} 
                                    selectedItem={pricingBasis.find(pricingBasis=>{return biddingDetails.pricingBasis === pricingBasis.value})} 
                                    displayKey="name" 
                                    name="pricingBasis" 
                                    label="Select Unit" 
                                    onSelect={this.onSelect}
                                    hasError={submitted && !pricingBasis.find(pricingBasis=>{return biddingDetails.pricingBasis === pricingBasis.value})}
                                />
                            </div>}
                        </React.Fragment>
                    }

                    {viewType === TRIP_TYPE && <div className={Cx("mb-40", {
                        "flex": !CENTURY_PLY.includes(rfq.companyId)
                    })}>
                        {CENTURY_PLY.includes(rfq.companyId) ?
                        <> 
                            <SubHeading text="LPP" className="mb-10"/>
                            <Input onChange={this.onChange} value={biddingDetails.lpp} name="lpp" className="mr-5"/>
                        </> : 
                        <div className="mr-10">
                            {!isVishaka() && <div className="flex mb-10">
                                <SubHeading text="LPP: "/>
                                <div className="flex fs-18 fSemibold">
                                    <div className="ml-5 col-1">
                                        {/* <Input onChange={this.onChange} value={biddingDetails.lpp} name="lpp" placeholder="eg. 100"/> */}
                                        {lppDetails && <span>{lppDetails.lpp}</span>} {' '}
                                        {lppDetails && <span>{(lppDetails.pricing_basis || '').replace(' per ', '/')}</span>}
                                    </div>
                                </div>
                            </div>}
                            {GREEN_PLY.includes(rfq.companyId) && <div className="fs-14 mb-10 fSemibold"><span>PTPK: </span>{lppDetails && <span className="theme-color">{lppDetails.pptk_value || '-'}</span>}</div>}
                            {([...KRBL].includes(rfq.companyId) || isAdaniWilmar()) && 
                            <>
                                <div className="fs-14 mb-10 fSemibold"><span>Average LPP: </span>{lppDetails && <span className="theme-color">{lppDetails.average_lpp || '-'}</span>}</div>
                            </>}
                            {!isVishaka() && <div className="fs-14 mb-10 fSemibold"><span>LPP Date: </span>{lppDetails && <span className="theme-color">{lppDetails.lpp_date_time && Moment(lppDetails.lpp_date_time).format('DD MMM YYYY') || '-'}</span>}</div>}
                            {!isVishaka() &&<div className="fs-14 fSemibold"><span>Vehicle Type: </span>{lppDetails && <span className="theme-color">{lppDetails.lpp_vehicle_type || '-'}</span>}</div>}               
                            { getUser().isShowDphDetails && 
                             <div className="mt-10">
                           <div className="fs-14 mb-10 fSemibold"><span>City: </span>{dphResult && <span className="theme-color">{dphResult.city }</span>}</div>
                            <div className="fs-14 mb-10 fSemibold"><span>Diesel Price: ₹</span>
                            {/* {dphResult && <span className="theme-color">{dphResult[0].diesel}</span>} */}
                            <Input type="number" onChange={this.onChange} value={biddingDetails.diesel_price ? biddingDetails.diesel_price : 0} name="dieselprice" className="theme-color" />
                            </div>
                            <div className="fs-14 mb-10 fSemibold"><span>Diesel Price Date: </span>{dphResult && <span className="theme-color">{dphResult.date}</span>}</div>
                            </div>}
                        </div> }
                        {/* <div className="mr-10 col-3">
                            <SubHeading text="Date" className="mb-10 tCenter"/>
                            <div className="flex">
                                <div className="mr-5 pv-10 tCenter col-1">
                                    <Input onChange={this.onChange} value={biddingDetails.lpp} name="lpp" placeholder="eg. 100"/>
                                    {lppDetails && <span>{lppDetails.lpp_date_time && Moment(lppDetails.lpp_date_time).format('DD MMM YYYY')}</span>}
                                </div>
                            </div>
                        </div>  */}
                    </div>}
                    {viewType === TRIP_TYPE &&  ftlContractType !== 2 && <div className="mb-40">
                        <SubHeading text="TAT" className="mb-10"/>
                        <div className="flex">
                            <Input onChange={this.onChange} 
                            value={isCoromandel() ? this.props.trip.tat : biddingDetails.tatValue} 
                            name="tatValue" 
                            className="mr-5 wt-50"/>
                            <Dropdown 
                            items={[...TAT_UNITS]} 
                            selectedItem={TAT_UNITS.find(tatUnit=>{return biddingDetails.tatUnit === tatUnit.value})}
                            name="tatUnit"
                            displayKey="name" 
                            label="Select Unit"
                            className="col-2 ht-40" 
                            onSelect={this.onSelect}
                            />
                        </div>
                    </div>}
                    { rfqServiceType === 4 && viewType === TRIP_TYPE &&
                        <Fragment>
                            <div className="mb-40">
                                <SubHeading text="CI No." className="mb-10"/>
                                <Input onChange={this.onChange} value={biddingDetails.cinNo} name="cinNo" />
                            </div>
                            <div className="mb-40">
                                <SubHeading text="Cargo Weight" className="mb-10"/>
                                <Input onChange={this.onChange} value={biddingDetails.cargoWeight} name="cargoWeight" />
                            </div>
                        </Fragment>
                   }
                   {BEAM.includes(getUser().companyId) && viewType === TRIP_TYPE &&
                        <div className="mb-40">
                        <SubHeading text="Budget" className="mb-10"/>
                        <Input onChange={this.onChange} value={biddingDetails.budget} name="budget" />
                    </div>}
                    {this.shouldRenderDieselprice() && viewType === TRIP_TYPE &&
                             <div className="mt-10">
                            <div className="fs-14 mb-10 fSemibold"><span>Diesel Price: ₹</span>{isBeamS()&&<span className="error-color"><b>*</b></span>}
                            <Input type="number" onChange={this.onChange} value={biddingDetails.diesel_price ? biddingDetails.diesel_price : 0} name="dieselprice" className="theme-color" />
                            {/* {!biddingDetails.diesel_price && <span className={'error-color fs-12'}>{'Please Enter Diesel Price'}</span>} */}
                            </div>
                            </div>}
                </div>
                {rfqType !== 9 && <div className="col-2 pl-20">
                    { type !== 'addTrip' &&
                        [
                            <Heading type="medium" text="Payment Info" className="mb-20"/>,
                            (rfqType === 5 && HIKAL.includes(getUser().companyId)) ?
                            <>
                            <div className="mb-50">
                                <SubHeading text="Inco Terms" className="mb-20"/>
                                <Dropdown 
                                items={incotermsList} 
                                selectedItem={incotermsList.find(incoterm =>{return (biddingDetails.incoterms || {}).id === incoterm.id})}
                                displayKey="name" 
                                name="incoterms" 
                                label="Select Inco Terms" 
                                canClear={true}
                                onSelect={this.onSelectIncoTerms}
                                />
                            </div>
                            </> :
                            <>
                            <div className="mb-50">
                                <SubHeading text="Payment Terms" className="mb-20"/>
                                <div className="flex flex-middle fSemibold header-dark-color">
                                    <Checkbox label="To Be Billed" checked = {biddingDetails.paymentTerms === 2} className="mr-20" onCheck={this.changePaymentTerms.bind(this, 2, 'To Be Billed')}/>
                                    <Checkbox label="To Pay" checked = {biddingDetails.paymentTerms === 1} className="mr-20" onCheck={this.changePaymentTerms.bind(this, 1, 'To Pay')}/>
                                    <Checkbox label="Both" checked = {biddingDetails.paymentTerms === 3}  onCheck={this.changePaymentTerms.bind(this, 3, 'Both')}/>
                                </div>
                            </div>
                            </>,
                            <div className="mb-40 mt--3">
                                <SubHeading text="Payment Cycle" className="mb-10" mandatory={[...MITSUI,...BEAM].includes(rfq.companyId) ? false : true}/>
                                <Dropdown 
                                items={paymentCycles} 
                                selectedItem={paymentCycles.find(paymentCycle=>{return biddingDetails.paymentCycle === paymentCycle.value})}
                                displayKey="name" 
                                name="paymentCycle" 
                                label="Select Cycle" 
                                canClear={true}
                                onSelect={this.onSelect}
                                hasError={submitted && ![...MITSUI,...BEAM].includes(rfq.companyId) && !paymentCycles.find(paymentCycle=>{return biddingDetails.paymentCycle === paymentCycle.value})}
                                />
                            </div>
                        ]
                    }
                    
                    {viewType === TRIP_TYPE &&  
                        <div className={isAdaniWilmar() ? 'mb-30' : "mb-40"}>
                            {viewType === TRIP_TYPE && this.shouldRenderSystemSuggestedPrice(rfq) && 
                            // rfq.biddingDetails && rfq.biddingDetails.pricingBasis && rfq.biddingDetails.pricingBasis === 6 && lppDetails && lppDetails.pricing_basis === 'Rate/MT' && 
                            <div className="flex fs-18 mb-10">
                                <SubHeading text="System Suggested Price:"/>
                                <div className="ml-5 fSemibold">
                                    {biddingDetails && <span>{biddingDetails.systemSuggestedPrice == 0 ? 'N/A' : (biddingDetails.systemSuggestedPrice || 'N/A')}</span>} {' '}
                                    {lppDetails && biddingDetails.systemSuggestedPrice && <span>{(lppDetails.pricing_basis || '').replace(' per ', '/') || ''}</span> || ''}
                                </div>
                            </div>
                            }
                            <div className={Cx("", {
                                'flex': isAdaniWilmar()
                                })}>
                                <SubHeading text="Ceiling Price" className={Cx("mr-5", {
                                    'mt-10': isAdaniWilmar(),
                                    'mb-10': !isAdaniWilmar()
                                })}/>
                                <div className="flex">
                                    <Input type="number" onChange={this.onChange} value={biddingDetails.qbr} name="qbr" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()} className={Cx("wt-150", {
                                        'theme-color': biddingDetails.systemSuggestedPrice && biddingDetails.qbr <= biddingDetails.systemSuggestedPrice,
                                        'error-color': biddingDetails.systemSuggestedPrice && biddingDetails.qbr > biddingDetails.systemSuggestedPrice
                                    })} />
                                    {lppDetails && <div className="ml-10 mt-10 fs-18">{(lppDetails.pricing_basis || '').replace(' per ', '/')}</div>}
                                    
                                </div>
                                {submitted && !biddingDetails.qbr && GREEN_PLY.includes(rfq.companyId) && <span className="error-color fs-14 fSemibold op-7 ml-5">Enter the Ceiling Price</span>}
                            </div>
                            {isAdaniWilmar() && [6, 17].includes(this.biddingDetails.pricingBasis) && <span className="orange-dark-color fs-14 fBold ml-5">{`Enter the Ceiling Price ${this.getPricingBasis(this.biddingDetails.pricingBasis)}`}</span>}
                        </div>
                    }

                    {viewType === TRIP_TYPE &&  ftlContractType !== 2 && <div className="mb-40">
                            {!isVishaka() && <SubHeading text="Business Volume" className="mb-10" mandatory={rfqServiceType === 4 || rfq.rfqDetails.tripsType === 2}/>}
                            {isVishaka() && <div className="header-medium-color fBold fs-16 mb-5">
                                Business Volume<sup className="danger-color ml-2 pr t-4">*</sup>
                            </div>}
                        <div className="flex">
                            <div className="wt-80 mr-5">
                                <Input onChange={this.onChange} value={biddingDetails.businessVolumeValue} name="businessVolumeValue" placeholder="Eg. 100"/>
                                {submitted && !biddingDetails.businessVolumeValue && <span className={'error-color fs-12'}>{'Please Enter Business Volume'}</span>}
                            </div>
                            <Dropdown 
                            items={businessVolumes} 
                            selectedItem={businessVolumes.find(businessVolumeUnit=>{return biddingDetails.businessVolumeUnit === businessVolumeUnit.value})}
                            name="businessVolumeUnit" 
                            displayKey="name" 
                            label="Select Unit" 
                            className="flex-1 ht-40"
                            hasError={submitted && !biddingDetails.businessVolumeUnit}
                            onSelect={this.onSelect}/>
                        </div>
                    </div>}

                    {rfqServiceType === 4 && viewType === TRIP_TYPE &&
                        <div className="mb-40">
                            <SubHeading text="Job No" className="mb-10"/>
                            <Input onChange={this.onChange} value={biddingDetails.jobNo} name="jobNo" />
                        </div>
                    }
                </div>}
            </div>
            {this.state.isConfirmation && 
                <ConfirmationPopup
                    text="Entered Ceiling Price is more than the 10% of the System Suggested Price, Do you want to continue?"
                    onCancel={this.onCancel}
                    onConfirm={() => this.setState({ isConfirmation: false })}
                />}
            </Fragment>
        )
    }
}

export default BiddingAndPayment;
